import { getAssetIndividualStaticPaths } from "~/modules/assets/api/getAssetIndividualStaticPaths";
import { getStaticProps } from "~/modules/assets/pages/individual/getStaticProps";
import { AssetPage } from "~/modules/assets/pages/individual/page";

// // // //

export const getStaticPaths = getAssetIndividualStaticPaths;
export { getStaticProps };
export default AssetPage;
